import Countries from './components/Countries';

const App = () => {
    return (
        <div>
           <Countries />
        </div>
    );
};

export default App;